import listActions from 'src/modules/affirmationProgram/list/affirmationProgramListActions';
import AffirmationProgramService from 'src/modules/affirmationProgram/affirmationProgramService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/store';
import Message from 'src/view/shared/message';

const prefix = 'AFFIRMATION_PROGRAM_UNARCHIVE';

const affirmationProgramUnarchiveActions = {
  UNARCHIVE_STARTED: `${prefix}_UNARCHIVE_STARTED`,
  UNARCHIVE_SUCCESS: `${prefix}_UNARCHIVE_SUCCESS`,
  UNARCHIVE_ERROR: `${prefix}_UNARCHIVE_ERROR`,

  UNARCHIVE_ALL_STARTED: `${prefix}_UNARCHIVE_ALL_STARTED`,
  UNARCHIVE_ALL_SUCCESS: `${prefix}_UNARCHIVE_ALL_SUCCESS`,
  UNARCHIVE_ALL_ERROR: `${prefix}_UNARCHIVE_ALL_ERROR`,

  doUnarchive: (id) => async (dispatch) => {
    try {
      dispatch({
        type:
          affirmationProgramUnarchiveActions.UNARCHIVE_STARTED,
      });

      await AffirmationProgramService.unarchiveAll([id]);

      dispatch({
        type:
          affirmationProgramUnarchiveActions.UNARCHIVE_SUCCESS,
      });

      Message.success(
        i18n(
          'entities.affirmationProgram.unarchive.success',
        ),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/affirmation-program');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type:
          affirmationProgramUnarchiveActions.UNARCHIVE_ERROR,
      });
    }
  },

  doUnarchiveAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type:
          affirmationProgramUnarchiveActions.UNARCHIVE_ALL_STARTED,
      });

      await AffirmationProgramService.unarchiveAll(ids);

      dispatch({
        type:
          affirmationProgramUnarchiveActions.UNARCHIVE_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doClearAllSelected());
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n(
          'entities.affirmationProgram.unarchiveAll.success',
        ),
      );

      getHistory().push('/affirmation-program');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type:
          affirmationProgramUnarchiveActions.UNARCHIVE_ALL_ERROR,
      });
    }
  },
};

export default affirmationProgramUnarchiveActions;
